import { useCallback } from 'react'
import { useParams } from 'react-router-dom'
// import { toast } from 'react-toastify'
import { useMutation } from 'react-query'

import { getMerchantHistories } from 'api/merchanthistories'
import { useHistoryLookupStore } from 'store/merchantHistories'
import { DropDownItem } from 'types/components'
import { MerchantHistoriesFetchParamsTypes } from 'types/merchantHistories'

export const useMemberHistoryLookup = () => {
  const { traderId } = useParams()
  const memberTraderId = parseInt(String(traderId) || '0')

  const historyLookupModStatus = useHistoryLookupStore(
    (state) => state.historyLookupModStatus
  )
  const historyLookupModStatusSet = useHistoryLookupStore(
    (state) => state.historyLookupModStatusSet
  )
  const historyLookupModErrors = useHistoryLookupStore(
    (state) => state.historyLookupModErrors
  )
  const historyLookupModErrorsSet = useHistoryLookupStore(
    (state) => state.historyLookupModErrorsSet
  )
  const historyLookup = useHistoryLookupStore((state) => state.historyLookup)
  const historyLookupSet = useHistoryLookupStore(
    (state) => state.historyLookupSet
  )

  const mutation = useMutation({
    mutationFn: getMerchantHistories,
    mutationKey: 'useHistoryLookup',
    onMutate: (values) => {
      historyLookupModStatusSet('loading')
    },
    onSuccess: (getHistoryResponse) => {
      historyLookupSet(getHistoryResponse.data)
      historyLookupModStatusSet('success')
    },
    onError: (error) => {
      historyLookupSet([])
      historyLookupModStatusSet('fail')
    },
  })

  const handleHistoryLookup = useCallback(
    async (getHistoryIdentsParams: MerchantHistoriesFetchParamsTypes) => {
      const historyLookupData = await mutation.mutateAsync(
        getHistoryIdentsParams
      )
      return historyLookupData.data
    },
    [mutation]
  )

  const editedByOptionsLoader = useCallback(
    async (inputValue: string): Promise<DropDownItem[]> => {
      if (inputValue.length < 3) return []
      const historyLookupData = await handleHistoryLookup({
        traderId: memberTraderId,
        programUsername: inputValue,
      })
      return historyLookupData.map((item) => ({
        label: String(item.programUser),
        value: String(item.programUser),
      }))
    },
    [handleHistoryLookup]
  )

  return {
    memberHistoryNameOptionsLoader: editedByOptionsLoader,
    memberHistoryIdents: historyLookup,
    memberHistoryIdentsModStatus: historyLookupModStatus,
    memberHistoryIdentsModErrors: historyLookupModErrors,
  }
}
